export function convertToEmbedUrl(url: string): string {
  try {
    // Handle youtu.be format
    const youtubeShortRegex = /youtu\.be\/([a-zA-Z0-9_-]+)(\?.*)?/;
    const youtubeMatch = url.match(youtubeShortRegex);
    
    if (youtubeMatch) {
      const videoId = youtubeMatch[1];
      const params = new URLSearchParams(youtubeMatch[2] || '');
      const startTime = params.get('t') || params.get('start');
      
      return `https://www.youtube.com/embed/${videoId}${startTime ? `?start=${startTime}` : ''}`;
    }
    
    // Handle youtube.com format
    const youtubeUrlRegex = /youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)(\S*)/;
    const standardMatch = url.match(youtubeUrlRegex);
    
    if (standardMatch) {
      const videoId = standardMatch[1];
      const params = new URLSearchParams(standardMatch[2]);
      const startTime = params.get('t') || params.get('start');
      
      return `https://www.youtube.com/embed/${videoId}${startTime ? `?start=${startTime}` : ''}`;
    }
    
    // If it's already an embed URL or not a YouTube URL, return as is
    return url;
  } catch (error) {
    console.error('Error converting video URL:', error);
    return url;
  }
}